import { render, staticRenderFns } from "./IndexThreeAds.vue?vue&type=template&id=6457d9e2&scoped=true&"
import script from "./IndexThreeAds.vue?vue&type=script&lang=js&"
export * from "./IndexThreeAds.vue?vue&type=script&lang=js&"
import style0 from "./IndexThreeAds.vue?vue&type=style&index=0&id=6457d9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457d9e2",
  null
  
)

export default component.exports